<template>
    <div class="case-detail-container">
      <roof-search :middleContent="false" :rightContent="false" :placeholder="true" v-show="isShowNav"></roof-search>
      <div class="slider-container">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item,index) in caseDetails.wrap_imgs" :key="index" @click="previewImg(index)">
            <van-image
              width="100%"
              :src="cdnUrl+item"
            />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="case-content">
        <div class="case-title van-multi-ellipsis--l2">
          {{caseDetails.title}}
        </div>
        <van-divider :style="{borderColor: '#ECECEC'}"/>
        <div class="case-detail footer" v-html="caseDetails.desc" ref="caseDetails" @click="getImage($event)"></div>
      </div>
    </div>
</template>

<script>
import roofSearch from '@/components/roof-search'
import { getExampleDetail } from '@/api/caseShare'
import { ImagePreview } from 'vant'
import { wxShare } from '@/libs/wxjssdk'
export default {
    components: {
        roofSearch
    },
    data () {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            id: '',
            caseDetails: {},
            isShowNav: false
        }
    },
    created () {
        this.$toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0
        })
        var query = this.$route.query
        this.id = query.id || ''
        this.isShowNav = query.isShowNav || false
        this.getExampleDetailPort()
    },
    mounted () {
        // this.$refs.caseDetails.addEventListener('click', (e) => {
        //   console.log('单击了', e)
        //   console.log(e.toElement.src)
        // })
    },
    methods: {
        sharePage () {
            const params = {
                title: `${this.caseDetails.title}`, // 分享标题
                desc: '来自客户案例分享', // 分享描述
                link: `${window.location.href}&isShowNav=true`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: `${this.cdnUrl}${this.caseDetails.img_url}` // 分享图标
            }
            wxShare(params)
        },
        getImage (even) {
         
          let img = []
          img.push(even.target.currentSrc)
          //  console.log(img);
          ImagePreview({
                images: img,
                startPosition: 0
            })
        },
        // 单击预览图片
        previewImg (index) {
            var wrapImgs = []
            this.caseDetails.wrap_imgs.map((val) => {
                wrapImgs.push(this.cdnUrl + val)
            })
            // console.log('查看',wrapImgs);
            ImagePreview({
                images: wrapImgs,
                startPosition: index
            })
        },
        /** 网络请求 **/
        // 根据id 获取案例分享详情
        getExampleDetailPort () {
            getExampleDetail({ id: this.id }).then(res => {
                if (res.errCode === 0) {
                    var data = res.data
                    var caseDetails = { ...data }
                    caseDetails.desc = JSON.parse(caseDetails.desc)
                    caseDetails.wrap_imgs = JSON.parse(caseDetails.wrap_imgs)
                    this.caseDetails = caseDetails
                    document.title = caseDetails.title
                    this.sharePage()
                } else {
                    this.$toast(res.errMsg)
                }
                this.$toast.clear()
            }).catch(err => {
                console.log('案例分享详情接口失败', err)
                this.$toast('案例分享详情接口失败')
            })
        }
    }
}
</script>

<style lang="scss">
.case-detail-container{
  background: #fff;
  .slider-container{
    width: 100%;
    height: rem(154);
    background: #cfcfcf;
    .my-swipe{
      height: 100%;
      .slider-img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .case-content{
    padding: 0 rem(20) rem(35);
    .case-title{
      margin: rem(13) 0;
      font-size: rem(15);
      font-weight: 500;
      color: #2C2C2C;
      line-height: rem(25);
      position: relative;
      padding-left: rem(13);
      &:after{
        content: '';
        width: rem(7);
        height: rem(17);
        background: $base-color;
        position: absolute;
        top: rem(5);
        left: 0;
      }
    }
    .case-detail{
      overflow: hidden;
      img{
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
